import { z } from 'zod';

import { userRoleSchema } from './user-role';

const profileVisibilityUserSchema = z.object({
    id: z.uuid(),
    emailAddress: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
});

export type ProfileVisibilityUser = z.infer<typeof profileVisibilityUserSchema>;

export const profileVisibilityUserSearchResponseSchema = profileVisibilityUserSchema.array();

export type ProfileVisibilityUserSearchResponse = z.infer<typeof profileVisibilityUserSearchResponseSchema>;

const sectionVisibilityBaseSchema = z.object({
    everyone: z.boolean(),
    roles: userRoleSchema.array(),
});

export type SectionVisibilityBase = z.infer<typeof sectionVisibilityBaseSchema>;

export const userProfileVisibilityBaseSchema = z.object({
    ambitionsVisibility: sectionVisibilityBaseSchema,
    historyVisibility: sectionVisibilityBaseSchema,
    overallVisibility: sectionVisibilityBaseSchema,
    personalInfoVisibility: sectionVisibilityBaseSchema,
    skillsVisibility: sectionVisibilityBaseSchema,
});

export type UserProfileVisibilityBase = z.infer<typeof userProfileVisibilityBaseSchema>;

const sectionVisibilityResponseSchema = sectionVisibilityBaseSchema.extend({
    users: profileVisibilityUserSchema.array(),
});

const sectionVisibilityRequestSchema = sectionVisibilityBaseSchema.extend({
    users: z.uuid().array(),
});

export type SectionVisibilityResponse = z.infer<typeof sectionVisibilityResponseSchema>;

export type SectionVisibilityRequest = z.infer<typeof sectionVisibilityRequestSchema>;

export const userProfileVisibilityResponseSchema = z.object({
    ambitionsVisibility: sectionVisibilityResponseSchema,
    historyVisibility: sectionVisibilityResponseSchema,
    isVisible: z.boolean(),
    overallVisibility: sectionVisibilityResponseSchema,
    personalInfoVisibility: sectionVisibilityResponseSchema,
    skillsVisibility: sectionVisibilityResponseSchema,
});

export const userProfileVisibilityPresetsSchema = z.enum(['everyone', 'recruiters', 'recruiters_all', 'private']);

export type UserProfileVisibilityPresets = z.infer<typeof userProfileVisibilityPresetsSchema>;

export const userProfileVisibilityRequestSchema = z.object({
    ambitionsVisibility: sectionVisibilityRequestSchema.optional(),
    historyVisibility: sectionVisibilityRequestSchema.optional(),
    overallVisibility: sectionVisibilityRequestSchema.optional(),
    personalInfoVisibility: sectionVisibilityRequestSchema.optional(),
    preset: userProfileVisibilityPresetsSchema.optional(),
    skillsVisibility: sectionVisibilityRequestSchema.optional(),
});

const sectionKey = z.union([
    z.literal('ambitionsVisibility'),
    z.literal('historyVisibility'),
    z.literal('personalInfoVisibility'),
    z.literal('skillsVisibility'),
    z.literal('overallVisibility'),
]);

export type SectionKey = z.infer<typeof sectionKey>;

export type UserProfileVisibilityResponse = z.infer<typeof userProfileVisibilityResponseSchema>;

export const userProfileVisibilityTemplateResponseSchema = z.object({
    minimum: userProfileVisibilityBaseSchema,
});

export type UserProfileVisibilityTemplateResponse = z.infer<typeof userProfileVisibilityTemplateResponseSchema>;

export type UserProfileVisibilityRequest = z.infer<typeof userProfileVisibilityRequestSchema>;
